import { z } from 'zod';
import { featureFlagsSchema } from '../../profiles/profile.schema';

export const privacyConfigSchema = z
  .object({
    anonymize: z.boolean().default(false),
  })
  .default({ anonymize: false });

export const appConfigSchema = z.object({
  privacy: privacyConfigSchema,
  features: featureFlagsSchema,
});

export type PrivacyConfig = z.infer<typeof privacyConfigSchema>;
export type AppConfig = z.infer<typeof appConfigSchema>;
export type { FeatureFlags } from '../../profiles/profile.schema';

export function parseAppConfig(raw: unknown): AppConfig {
  return appConfigSchema.parse(raw);
}
